import { FunctionComponent, ReactElement } from 'react';

import SelfcareBanner from '@savgroup-front-common/core/molecules/SelfcareBanner';

import useBannerUrl from './hooks/useBannerUrl';

const Banner: FunctionComponent<{
  children?: ReactElement | ReactElement[];
}> = ({ children }) => {
  const bannerUrl = useBannerUrl();

  return <SelfcareBanner bannerUrl={bannerUrl}>{children}</SelfcareBanner>;
};

export default Banner;
